<div class="px-[26px] py-5">
  @if (address(); as addressData) {
    <div class="flex items-start gap-3 rounded-xl bg-muted/50 px-4 py-3.5">
      <ng-icon name="lucideLock" size="15" class="mt-0.5 shrink-0 text-muted-foreground" />
      <div class="min-w-0 flex-1">
        <p class="text-sm font-normal text-foreground">
          {{ addressData.street }} {{ addressData.houseNumber }}
        </p>
        <p class="mt-0.5 text-dense text-muted-foreground">
          {{ addressData.postalCode }} {{ addressData.city }}
        </p>
        <p class="mt-1.5 font-mono text-2xs text-muted-foreground">
          {{ addressData.latitude.toFixed(6) }} · {{ addressData.longitude.toFixed(6) }}
        </p>
      </div>
      <p class="max-w-[190px] text-right text-2xs text-muted-foreground">
        Die Adresse definiert die Analyse und ist fest.
      </p>
    </div>
  }

  <h3 class="mt-5 text-sm font-bold">Gebäudedaten der Adresse</h3>
  <p class="mt-1 text-xs text-muted-foreground">Diese Angaben gelten für alle Analysen dieser Adresse.</p>
  <div class="mt-3 grid grid-cols-1 gap-x-4 gap-y-3.5 sm:grid-cols-2">
    <div class="min-w-0">
      <label class="mb-1.5 block text-dense font-normal text-foreground">Dachtyp</label>
      <brn-select class="w-full" placeholder="Nicht angegeben" [ngModel]="editRoofType() || ''" (ngModelChange)="editRoofType.set($event === '' ? null : $event)">
        <hlm-select-trigger class="h-9 w-full rounded-[10px] text-dense"><hlm-select-value /></hlm-select-trigger>
        <hlm-select-content>
          <hlm-option value="">Nicht angegeben</hlm-option>
          <hlm-option value="normal">Schrägdach</hlm-option>
          <hlm-option value="flat">Flachdach</hlm-option>
          <hlm-option value="both">Gemischt</hlm-option>
        </hlm-select-content>
      </brn-select>
    </div>

    <div class="min-w-0">
      <label class="mb-1.5 block text-dense font-normal text-foreground">Gebäudetyp</label>
      <brn-select class="w-full" placeholder="Nicht angegeben" [ngModel]="editBuildingType() || ''" (ngModelChange)="editBuildingType.set($event === '' ? null : $event)">
        <hlm-select-trigger class="h-9 w-full rounded-[10px] text-dense"><hlm-select-value /></hlm-select-trigger>
        <hlm-select-content>
          <hlm-option value="">Nicht angegeben</hlm-option>
          <hlm-option value="single_family">Einfamilienhaus</hlm-option>
          <hlm-option value="multi_family">Mehrfamilienhaus</hlm-option>
        </hlm-select-content>
      </brn-select>
    </div>

    <div class="min-w-0">
      <label class="mb-1.5 block text-dense font-normal text-foreground">Bestandsanlage</label>
      <brn-select class="w-full" placeholder="Nicht angegeben" [ngModel]="editSolarStatus() || ''" (ngModelChange)="editSolarStatus.set($event === '' ? null : $event)">
        <hlm-select-trigger class="h-9 w-full rounded-[10px] text-dense"><hlm-select-value /></hlm-select-trigger>
        <hlm-select-content>
          <hlm-option value="">Nicht angegeben</hlm-option>
          <hlm-option value="yes">Ja</hlm-option>
          <hlm-option value="no">Nein</hlm-option>
        </hlm-select-content>
      </brn-select>
    </div>

  </div>
  <h3 class="mt-6 text-sm font-bold">Annahmen dieser Analyse</h3>
  <p class="mt-1 text-xs text-muted-foreground">Verbrauch und Strompreis gelten nur für diese Analyse und neue Planungen. Bestehende Ergebnisse behalten ihre Berechnungswerte.</p>
  <div class="mt-3 grid grid-cols-1 gap-x-4 gap-y-3.5 sm:grid-cols-2">
    <div class="min-w-0">
      <label class="mb-1.5 block text-dense font-normal text-foreground">Jahresverbrauch</label>
      <div class="flex items-center gap-2">
        <input hlmInput type="number" min="1" class="h-9 min-w-0 flex-1 rounded-[10px] font-mono text-dense" [value]="editPower()" (input)="editPower.set($any($event.target).valueAsNumber || 0)" />
        <span class="w-[52px] shrink-0 font-mono text-2xs text-muted-foreground">kWh/Jahr</span>
      </div>
    </div>

    <div class="min-w-0">
      <label class="mb-1.5 block text-dense font-normal text-foreground">Strompreis</label>
      <div class="flex items-center gap-2">
        <input hlmInput type="number" min="0.0001" step="0.0001" class="h-9 min-w-0 flex-1 rounded-[10px] font-mono text-dense" [value]="editPrice()" (input)="editPrice.set($any($event.target).valueAsNumber || 0)" />
        <span class="w-[52px] shrink-0 font-mono text-2xs text-muted-foreground">€/kWh</span>
      </div>
    </div>
  </div>
</div>

<div class="flex items-center gap-2 border-t border-border/60 px-[26px] py-3.5">
  <span class="min-w-0 flex-1 font-mono text-2xs" [class.text-destructive]="saveStatus() === 'error'" [class.text-muted-foreground]="saveStatus() !== 'error'">
    @if (saveStatus() === 'saving') {
      Wird gespeichert …
    } @else if (saveStatus() === 'saved') {
      Gespeichert um {{ lastSavedAtFormatted() }}
    } @else if (saveStatus() === 'error') {
      Speichern fehlgeschlagen
    } @else if (isDirty()) {
      Ungespeicherte Änderungen
    }
  </span>
  <button hlmBtn variant="outline" type="button" class="h-9 rounded-[10px]" (click)="cancel()">Abbrechen</button>
  <button hlmBtn type="button" class="h-9 rounded-[10px]" [disabled]="saveStatus() === 'saving' || editPower() <= 0 || editPrice() <= 0" (click)="save()">Speichern</button>
</div>
